<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('promotions')"
      :columns="columns"
      :column_search="true"
      resource_url="/gym_member/promotion/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <promotion-modal ref="promotion_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import PromotionModal from "./promotion_modal/Index.vue";

export default {
  name: "PromotionDatatable",
  components: { GenericTable, PromotionModal },
  data() {
    let v = this;
    return {
      columns: [
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: true,
        //   width: "80%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          data: (row) => {
            let icon =
              row.settings.is_active == true
                ? `<span class="icon has-text-success"><i class="fa fa-check"></i></span>`
                : `<span class="icon has-text-danger"><i class="fa fa-times"></i></span>`;
            return `<div class="title is-6">${icon}<span>${row.name}</span></div>`;
          },
        },
        {
          title: v.$t("price"),
          name: "settings.price",
          searchable: true,
          data: (row) => {
            return format_currency(row.settings.price);
          },
        },
        {
          title: v.$t("validity months"),
          name: "settings.months_to_add",
          searchable: true,
          data: (row) => {
            return row.settings.months_to_add || "";
          },
        },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.promotion_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete promotion?"),
                    v,
                    () => {
                      del("/gym_member/promotion", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.promotion_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
